import React from 'react';
import { Box, Typography } from '@mui/material';
import { WidgetAddress } from '../../../../../components/widget/WidgetAddress';
import { useTranslation } from 'react-i18next';

export default function AddressSection ({ address, title }) {
    const { t } = useTranslation();
    return (
        <Box padding={'1rem'} display='flex' alignItems='flex-start' flexDirection='column' gap='1rem' margin='16px' >
            <Box display='flex' alignItems='flex-start' justifyContent='start' width='100%' >
                <Typography variant='h1' >{title}</Typography>
            </Box>
            <Box display='flex' flexWrap='wrap' gap='16px'>
                <WidgetAddress title={t('details.subInputs.country')} value={address?.country || '-'} width={'430px'}/>
                <WidgetAddress title={t('details.subInputs.province')} value={address?.state || '-'} width={'430px'}/>
                <WidgetAddress title={t('details.subInputs.location')} value={address?.city || '-'} width={'430px'}/>
                <WidgetAddress title={t('details.subInputs.street')} value={`${address?.streetAddr || '-'} ${address?.streetNum || ''} ${address?.floor || ''} ${address?.dept || ''}` || '-'} width={'430px'}/>
                <WidgetAddress title={t('details.subInputs.zipCode')} value={address?.zipCode || '-'} width={'430px'}/>
            </Box>
        </Box>
    );
}
